import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl, BorderRadiusControl, StyleControl } from '../CommonProperties';

const AssetHistoryProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor"/>
            <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="currentColor"/>
          </svg>
          자산 내역 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제목</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.title || '자산 내역'} 
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>빈 내역 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.emptyText || '자산 내역이 없습니다.'} 
            onChange={(e) => handleComponentPropsChange('emptyText', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      
      {/* 스타일 컨트롤 */}
      <PaddingControl />
      <BorderRadiusControl />
      <StyleControl />
    </>
  );
};

export default AssetHistoryProperties;
